import SimpleDrawer from '../../shared/simple-drawer';
import { ActivityModel } from '../../../types';
import AvatarChip from '../../shared/avatar-chip';
import { eventNames } from '../../shared/event-names';
import ModelDetailsDisplay from '../../shared/model-details-display';
import React, { useMemo } from 'react';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Check from '@mui/icons-material/Check';

interface LogDetailsDrawerProps {
  open: boolean;
  handleClose: () => void;
  selectedLog: ActivityModel | null;
}

export default function LogDetailsDrawerOld({
  open,
  handleClose,
  selectedLog,
}: Readonly<LogDetailsDrawerProps>) {
  const name = selectedLog?.events[0]?.name || '';
  const parameters = selectedLog?.events[0]?.parameters || [];
  const event = eventNames.find((event) => event.value === name);

  function getEventDescription(
    event:
      | {
          value: string;
          label: string;
          messageFormat: (props: never) => string;
        }
      | undefined
  ) {
    if (!event) {
      return 'N/A';
    } else if (event.messageFormat) {
      const formattedParameters = parameters.map((param) => {
        return {
          [param.name]: param.value,
        };
      });
      const parametersObject = Object.assign({}, ...formattedParameters);
      return event.messageFormat(parametersObject as never);
    } else {
      return 'N/A';
    }
  }

  const logData: Record<string, React.ReactNode> = useMemo(() => {
    if (!selectedLog) return {};
    return {
      Actor: selectedLog.actor.email ? (
        <AvatarChip email={selectedLog.actor.email} type="User" />
      ) : (
        'N/A'
      ),
      'Event Type': selectedLog.events[0]?.type || 'N/A',
      'IP Address': selectedLog.ipAddress || 'N/A',
    };
  }, [selectedLog]);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100vw', md: '45%' },
        },
      }}
    >
      {selectedLog && (
        <SimpleDrawer title="cPanel Log Details" onClose={handleClose}>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            {event ? event.label : name}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {getEventDescription(event)}
          </Typography>

          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{ color: 'text.secondary' }}
          >
            <Check fontSize="small" />
            <Typography variant="body2" color="inherit">
              Created:
              {new Date(selectedLog.id.time.value).toLocaleString() || 'N/A'}
            </Typography>
          </Stack>

          <ModelDetailsDisplay title="Basic Information" data={logData} />
        </SimpleDrawer>
      )}
    </Drawer>
  );
}
